import { render } from "./Management.vue?vue&type=template&id=4c4dc5b2&scoped=true&bindings={\"updateCounts\":\"options\",\"openClear\":\"options\",\"closeClear\":\"options\",\"clearResponses\":\"options\",\"submit\":\"options\",\"surveys\":\"data\",\"scales\":\"data\",\"baseurl\":\"data\",\"clearOpen\":\"data\",\"showCleared\":\"data\",\"resCount\":\"data\"}"
import script from "./Management.vue?vue&type=script&lang=js"
export * from "./Management.vue?vue&type=script&lang=js"

import "./Management.vue?vue&type=style&index=0&id=4c4dc5b2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c4dc5b2"

export default script